import { Azienda } from "./Azienda";
import { Fornitore } from "./Fornitore";
import { ArticoloCollegatoArticolo } from "./ArticoloCollegatoArticolo";
import { ArticoloCategoria } from "./ArticoloCategoria";
import { Allergene } from "./Allergene";
import { SezioneAggiuntiva } from "./SezioneAggiuntiva";
import { ArticoloDeliverect } from "./ArticoloDeliverect";

export class Articolo {
    id?: number;
    articoloDeliverectId?: string;
    codice?: string;
    urlImmagine?: string;
    nome?: string;
    descrizione?: string;
    prezzo?: number;
    costo?: number;
    unitaMisura?: string;
    fornitoreId?: Fornitore;
    aziendaId?: Azienda;
    sottoArticoli?: ArticoloCollegatoArticolo[];
    articoloCategoria?: ArticoloCategoria;
    tempoPreparazione?: number;
    allergeneList: Allergene[];
    sezioneAggiuntivaArticoloList?: SezioneAggiuntiva[];
    sezioneAggiuntivaList?: SezioneAggiuntiva[];
    articoloDeliverect?: ArticoloDeliverect;
    eatInTax: number;
    stampanteId?: number;
    vendutoAlPubblico?: boolean;
    externalId?: string;

    constructor() {
        this.nome = "";
        this.descrizione = "";
        this.costo = 0;
        this.codice = "";
        this.unitaMisura = "";
        this.urlImmagine = "";
        this.allergeneList = [];
        this.sezioneAggiuntivaArticoloList = [];
        this.sezioneAggiuntivaList = [];
        this.eatInTax = 0;
        this.vendutoAlPubblico = false;
        this.externalId = "";
    }

    static fromJson(json: any) {

        let result = new Articolo();
        result.id = json.id;
        result.articoloDeliverectId = json.articoloDeliverectId;
        result.nome = json.nome;
        result.descrizione = json.descrizione;

        if (json.prezzo != null && !isNaN(json.prezzo)) {
            result.prezzo = parseFloat(json.prezzo);
        } else {
            result.prezzo = 0;
        }

        if (json.costo != null && !isNaN(json.costo)) {
            result.costo = parseFloat(json.costo);
        } else {
            result.costo = 0;
        }

        result.codice = json.codice;
        result.unitaMisura = json.unitaMisura;
        result.urlImmagine = json.urlImmagine;
        result.tempoPreparazione = json.tempoPreparazione;

        if (json.sottoArticoli) {
            result.sottoArticoli = json.sottoArticoli.map((sottoArticolo: any) => ArticoloCollegatoArticolo.fromJson(sottoArticolo));
        }

        if (json.articoloCategoria) {
            result.articoloCategoria = ArticoloCategoria.fromJson(json.articoloCategoria);
        }

        if (json.fornitoreId) {
            result.fornitoreId = Fornitore.fromJson(json.fornitoreId);
        }

        if (json.aziendaId) {
            result.aziendaId = Azienda.fromJson(json.aziendaId);
        }

        if (json.sezioneAggiuntivaArticoloList) {
            result.sezioneAggiuntivaArticoloList = json.sezioneAggiuntivaArticoloList.map((sezioneAggiuntiva: any) => SezioneAggiuntiva.fromJson(sezioneAggiuntiva));
        }

        if (json.sezioneAggiuntivaList) {
            result.sezioneAggiuntivaList = json.sezioneAggiuntivaList.map((sezioneAggiuntiva: any) => SezioneAggiuntiva.fromJson(sezioneAggiuntiva));
        }

        if (json.allergeneList) {
            result.allergeneList = json.allergeneList.map((allergene: any) => Allergene.fromJson(allergene));
        }

        if (json.articoloDeliverect) {
            result.articoloDeliverect = ArticoloDeliverect.fromJson(json.articoloDeliverect);
        }

        if (json.eatInTax != null && !isNaN(json.eatInTax)) {
            result.eatInTax = json.eatInTax;
        } else {
            result.eatInTax = 0;
        }

        if (json.stampanteId != null && !isNaN(json.stampanteId)) {
            result.stampanteId = parseInt(json.stampanteId);
        }

        result.vendutoAlPubblico = json.vendutoAlPubblico;
        result.externalId = json.externalId;
        return result;
    }
}
